module.exports = __webpack_public_path__ + "static/media/satchels_list_item.aee0e7e8.png";